import { gallery } from '@/data/gallery';
import { localeStore } from '@/locale';
import { atom } from 'nanostores';

export class GalleryStore {
  $isOpened = atom(false);

  $pageIndex = atom(0);

  $isPrevActive = atom(false);

  $isNextActive = atom(false);

  $pages = atom([]);

  $slide = atom([]);

  slidesPerPage = 10;

  $planId = atom('');

  $widgetUrl = atom('');

  store;

  constructor(store) {
    this.store = store;
  }

  get maxPageCount() {
    return this.$pages.get().length;
  }

  init() {
    const slides = [...gallery[localeStore.lang]];
    const pages = [];
    while (slides.length) pages.push(slides.splice(0, this.slidesPerPage));
    this.$pages.set(pages);

    this.updateState();
  }

  openModal(planId) {
    if (!planId) {
      console.warn('Gallery: Cannot open empty planId!');
      return;
    }

    this.$isOpened.set(true);
    this.$planId.set(planId);
    this.$widgetUrl.set(`${window.location.origin}/widget?id=${planId}`);

    this.store.scrollStore.lock('gallery');
  }

  closeModal() {
    this.$isOpened.set(false);
    this.$planId.set('');
    this.$widgetUrl.set('');

    this.store.scrollStore.unlock('gallery');
  }

  setPageIndex(value) {
    this.$pageIndex.set(value);
    this.updateState();
  }

  nextPage() {
    if (this.$isNextActive.get()) this.setPageIndex(this.$pageIndex.get() + 1);
  }

  prevPage() {
    if (this.$isPrevActive.get()) this.setPageIndex(this.$pageIndex.get() - 1);
  }

  updateState() {
    const index = this.$pageIndex.get();
    const pages = this.$pages.get();
    this.$isPrevActive.set(index > 0);
    this.$isNextActive.set(index < this.maxPageCount - 1);
    this.$slide.set(pages[index]);
  }
}
